export const ADD_ON_CREATE_ERROR = 'quoteItems/ADD_ON_CREATE_ERROR';
export const ADD_ON_CREATE_REQUEST = 'quoteItems/ADD_ON_CREATE_REQUEST';
export const ADD_ON_CREATE_SUCCESS = 'quoteItems/ADD_ON_CREATE_SUCCESS';

export const ADD_ON_DELETE_ERROR = 'quoteItems/ADD_ON_DELETE_ERROR';
export const ADD_ON_DELETE_REQUEST = 'quoteItems/ADD_ON_DELETE_REQUEST';

export const ADD_ON_UPDATE_ERROR = 'quoteItems/ADD_ON_UPDATE_ERROR';
export const ADD_ON_UPDATE_REQUEST = 'quoteItems/ADD_ON_UPDATE_REQUEST';
export const ADD_ON_UPDATE_SUCCESS = 'quoteItems/ADD_ON_UPDATE_SUCCESS';

export const ADD_ON_CELL_UPDATE_ERROR = 'quoteItems/ADD_ON_CELL_UPDATE_ERROR';
export const ADD_ON_CELL_UPDATE_REQUEST =
  'quoteItems/ADD_ON_CELL_UPDATE_REQUEST';
export const ADD_ON_CELL_UPDATE_SUCCESS =
  'quoteItems/ADD_ON_CELL_UPDATE_SUCCESS';

export const UPDATE_ADD_ON_OVERRIDES_ERROR =
  'quoteItems/UPDATE_ADD_ON_OVERRIDES_ERROR';
export const UPDATE_ADD_ON_OVERRIDES_REQUEST =
  'quoteItems/UPDATE_ADD_ON_OVERRIDES_REQUEST';
export const UPDATE_ADD_ON_OVERRIDES_SUCCESS =
  'quoteItems/UPDATE_ADD_ON_OVERRIDES_SUCCESS';

export const LOCK_QUOTE_ITEM = 'quoteItemsTable/LOCK_QUOTE_ITEM';

export const TAKE_OVER_QUOTE_ITEM_REQUEST =
  'quoteItemsTable/TAKE_OVER_QUOTE_ITEM_REQUEST';

export const EXPAND_QUOTE_ITEM_REQUEST =
  'quoteItemsTable/EXPAND_QUOTE_ITEM_REQUEST';
export const EXPAND_QUOTE_ITEM_SUCCESS =
  'quoteItemsTable/EXPAND_QUOTE_ITEM_SUCCESS';
export const EXPAND_QUOTE_ITEM_ERROR =
  'quoteItemsTable/EXPAND_QUOTE_ITEM_ERROR';

export const COLLAPSE_QUOTE_ITEM = 'quoteItemsTable/COLLAPSE_QUOTE_ITEM';

export const QUOTE_ITEMS_RESET = 'quoteItems/QUOTE_ITEMS_RESET';

export const REORDER_ADD_ONS_REQUEST = 'quoteItems/REORDER_ADD_ONS_REQUEST';
export const REORDER_ADD_ONS_SUCCESS = 'quoteItems/REORDER_ADD_ONS_SUCCESS';
export const REORDER_ADD_ONS_ERROR = 'quoteItems/REORDER_ADD_ONS_ERROR';

export const FETCH_INITIAL_BRIEF_COMPONENTS_REQUEST =
  'quoteItems/FETCH_INITIAL_BRIEF_COMPONENTS_REQUEST';
export const FETCH_INITIAL_BRIEF_COMPONENTS_SUCCESS =
  'quoteItems/FETCH_INITIAL_BRIEF_COMPONENTS_SUCCESS';
export const FETCH_INITIAL_BRIEF_COMPONENTS_ERROR =
  'quoteItems/FETCH_INITIAL_BRIEF_COMPONENTS_ERROR';

export const RECEIVE_QUOTE_ITEM = 'quoteItems/RECEIVE_QUOTE_ITEM';
export const RECEIVE_QUOTE_ITEMS = 'quoteItems/RECEIVE_QUOTE_ITEMS';
export const REMOVE_QUOTE_ITEMS = 'quoteItems/REMOVE_QUOTE_ITEMS';
export const REPLACE_QUOTE_ITEMS = 'quoteItems/REPLACE_QUOTE_ITEMS';

export const UPDATE_QUOTE_ITEM_REQUEST = 'quoteItems/UPDATE_QUOTE_ITEM_REQUEST';
export const UPDATE_QUOTE_ITEM_SUCCESS = 'quoteItems/UPDATE_QUOTE_ITEM_SUCCESS';
export const UPDATE_QUOTE_ITEM_ERROR = 'quoteItems/UPDATE_QUOTE_ITEM_ERROR';

export const MAKE_QUOTE_ITEMS_ASSEMBLIES_REQUEST =
  'quoteItems/MAKE_QUOTE_ITEMS_ASSEMBLIES_REQUEST';
export const MAKE_QUOTE_ITEM_ASSEMBLY_REQUEST =
  'quoteItems/MAKE_QUOTE_ITEM_ASSEMBLY_REQUEST';
export const MAKE_QUOTE_ITEM_ASSEMBLY_SUCCESS =
  'quoteItems/MAKE_QUOTE_ITEM_ASSEMBLY_SUCCESS';
export const MAKE_QUOTE_ITEM_ASSEMBLY_ERROR =
  'quoteItems/MAKE_QUOTE_ITEM_ASSEMBLY_ERROR';

export const UPDATE_COMPONENT_REQUEST = 'quoteItems/UPDATE_COMPONENT_REQUEST';
export const UPDATE_COMPONENT_SUCCESS = 'quoteItems/UPDATE_COMPONENT_SUCCESS';
export const UPDATE_COMPONENT_ERROR = 'quoteItems/UPDATE_COMPONENT_ERROR';

export const UPDATE_OPERATION_REQUEST = 'quoteItems/UPDATE_OPERATION_REQUEST';
export const UPDATE_OPERATION_SUCCESS = 'quoteItems/UPDATE_OPERATION_SUCCESS';
export const UPDATE_OPERATION_ERROR = 'quoteItems/UPDATE_OPERATION_ERROR';

export const CREATE_OPERATION_REQUEST = 'quoteItems/CREATE_OPERATION_REQUEST';
export const CREATE_OPERATION_ERROR = 'quoteItems/CREATE_OPERATION_ERROR';
export const CREATE_OPERATION_SUCCESS = 'quoteItems/CREATE_OPERATION_SUCCESS';

export const DELETE_OPERATION_REQUEST = 'quoteItems/DELETE_OPERATION_REQUEST';
export const DELETE_OPERATION_ERROR = 'quoteItems/DELETE_OPERATION_ERROR';

export const RECEIVE_COMPONENT = 'quoteItems/RECEIVE_COMPONENT';
export const RECEIVE_COMPONENTS = 'quoteItems/RECEIVE_COMPONENTS';

export const RECEIVE_QUOTE_WORKFLOW = 'quoteItems/RECEIVE_QUOTE_WORKFLOW';

export const RECEIVE_ADD_ONS = 'quoteItems/RECEIVE_ADD_ONS';

export const UPDATE_OPERATION_OVERRIDES_ERROR =
  'operations/UPDATE_OPERATION_OVERRIDES_ERROR';
export const UPDATE_OPERATION_OVERRIDES_REQUEST =
  'operations/UPDATE_OPERATION_OVERRIDES_REQUEST';

export const UPDATE_OPERATION_OVERRIDES_CANCEL =
  'operations/UPDATE_OPERATION_OVERRIDES_CANCEL';

export const UPDATE_OPERATION_IS_OUTSIDE_SERVICE_ERROR =
  'operations/UPDATE_OPERATION_IS_OUTSIDE_SERVICE_ERROR';
export const UPDATE_OPERATION_IS_OUTSIDE_SERVICE_REQUEST =
  'operations/UPDATE_OPERATION_IS_OUTSIDE_SERVICE_REQUEST';
export const UPDATE_OPERATION_IS_OUTSIDE_SERVICE_SUCCESS =
  'operations/UPDATE_OPERATION_IS_OUTSIDE_SERVICE_SUCCESS';

export const REORDER_OPERATIONS_REQUEST =
  'operations/REORDER_OPERATIONS_REQUEST';
export const REORDER_OPERATIONS_SUCCESS =
  'operations/REORDER_OPERATIONS_SUCCESS';
export const REORDER_OPERATIONS_ERROR = 'operations/REORDER_OPERATIONS_ERROR';

export const CREATE_QUANTITY_REQUEST = 'quoteItems/CREATE_QUANTITY_REQUEST';
export const CREATE_QUANTITY_ERROR = 'quoteItems/CREATE_QUANTITY_ERROR';

export const UPDATE_QUANTITY_REQUEST = 'quoteItems/UPDATE_QUANTITY_REQUEST';
export const UPDATE_QUANTITY_SUCCESS = 'quoteItems/UPDATE_QUANTITY_SUCCESS';
export const UPDATE_QUANTITY_ERROR = 'quoteItems/UPDATE_QUANTITY_ERROR';

export const UPDATE_QUANTITIES_REQUEST = 'quoteItems/UPDATE_QUANTITIES_REQUEST';
export const UPDATE_QUANTITIES_SUCCESS = 'quoteItems/UPDATE_QUANTITIES_SUCCESS';
export const UPDATE_QUANTITIES_ERROR = 'quoteItems/UPDATE_QUANTITIES_ERROR';

export const DELETE_QUANTITY_REQUEST = 'quoteItems/DELETE_QUANTITY_REQUEST';
export const DELETE_QUANTITY_ERROR = 'quoteItems/DELETE_QUANTITY_ERROR';

export const RECEIVE_QUANTITIES = 'quoteItems/RECEIVE_QUANTITIES';

export const UPDATE_CELL_REQUEST = 'cells/UPDATE_CELL_REQUEST';
export const UPDATE_CELL_SUCCESS = 'cells/UPDATE_CELL_SUCCESS';
export const UPDATE_CELL_ERROR = 'cells/UPDATE_CELL_ERROR';

export const SELECT_FINISH_OPS_REQUEST = 'operations/SELECT_FINISH_OPS_REQUEST';
export const SELECT_FINISH_OPS_SUCCESS = 'operations/SELECT_FINISH_OPS_SUCCESS';
export const SELECT_FINISH_OPS_ERROR = 'operations/SELECT_FINISH_OPS_ERROR';

//TODO: QUOTE TYPES
export const RECEIVE_QUOTE_OP_DEFS = 'quotes/RECEIVE_QUOTE_OP_DEFS';

export const FETCH_COLLABORATORS = 'quotes/FETCH_COLLABORATORS';

export const COMPONENT_UPDATE_PENDING_START =
  'quoteItems/COMPONENT_UPDATE_PENDING_START';
export const COMPONENT_UPDATE_PENDING_FINISH =
  'quoteItems/COMPONENT_UPDATE_PENDING_FINISH';

export const CREATE_EXPEDITE_REQUEST = 'quoteItems/CREATE_EXPEDITE_REQUEST';
export const CREATE_EXPEDITE_SUCCESS = 'quoteItems/CREATE_EXPEDITE_SUCCESS';
export const CREATE_EXPEDITE_ERROR = 'quoteItems/CREATE_EXPEDITE_ERROR';

export const UPDATE_EXPEDITE_REQUEST = 'quoteItems/UPDATE_EXPEDITE_REQUEST';
export const UPDATE_EXPEDITE_SUCCESS = 'quoteItems/UPDATE_EXPEDITE_SUCCESS';
export const UPDATE_EXPEDITE_ERROR = 'quoteItems/UPDATE_EXPEDITE_ERROR';

export const DELETE_EXPEDITE_REQUEST = 'quoteItems/DELETE_EXPEDITE_REQUEST';
export const DELETE_EXPEDITE_SUCCESS = 'quoteItems/DELETE_EXPEDITE_SUCCESS';
export const DELETE_EXPEDITE_ERROR = 'quoteItems/DELETE_EXPEDITE_ERROR';

export const UPDATE_PART_FILENAME_ERROR =
  'quoteItems/UPDATE_PART_FILENAME_ERROR';
export const UPDATE_PART_FILENAME_REQUEST =
  'quoteItems/UPDATE_PART_FILENAME_REQUEST';
export const UPDATE_PART_FILENAME_SUCCESS =
  'quoteItems/UPDATE_PART_FILENAME_SUCCESS';

export const UPDATE_SUPPLIER_MATERIAL_REQUEST =
  'quoteItems/UPDATE_SUPPLIER_MATERIAL_REQUEST';
export const UPDATE_SUPPLIER_MATERIAL_SUCCESS =
  'quoteItems/UPDATE_SUPPLIER_MATERIAL_SUCCESS';
export const UPDATE_SUPPLIER_MATERIAL_ERROR =
  'quoteItems/UPDATE_SUPPLIER_MATERIAL_ERROR';

export const FORCE_QUOTE_ITEM_RECALCULATION_REQUEST =
  'quoteItems/FORCE_QUOTE_ITEM_RECALCULATION_REQUEST';
export const FORCE_QUOTE_ITEM_RECALCULATION_SUCCESS =
  'quoteItems/FORCE_QUOTE_ITEM_RECALCULATION_SUCCESS';
export const FORCE_QUOTE_ITEM_RECALCULATION_ERROR =
  'quoteItems/FORCE_QUOTE_ITEM_RECALCULATION_ERROR';

export const FORCE_COMPONENT_REGENERATION_REQUEST =
  'quoteItems/FORCE_COMPONENT_REGENERATION_REQUEST';
export const FORCE_COMPONENT_REGENERATION_SUCCESS =
  'quoteItems/FORCE_COMPONENT_REGENERATION_SUCCESS';
export const FORCE_COMPONENT_REGENERATION_ERROR =
  'quoteItems/FORCE_COMPONENT_REGENERATION_ERROR';

export const RECEIVE_COMPONENT_PROCESSING_STATUSES =
  'quoteItems/RECEIVE_COMPONENT_PROCESSING_STATUSES';
export const RECEIVE_COMPONENT_INTERROGATION_STATUSES =
  'quoteItems/RECEIVE_COMPONENT_INTERROGATION_STATUSES';

export const REFRESH_COMPONENT = 'quoteItems/REFRESH_COMPONENT';
export const REFRESH_QUOTE_ITEM = 'quoteItems/REFRESH_QUOTE_ITEM';

export const BRIEF_COMPONENT_ADD = 'quoteItems/BRIEF_COMPONENT_ADD';
export const BRIEF_COMPONENT_RECEIVE = 'quoteItems/BRIEF_COMPONENT_RECEIVE';
export const BRIEF_COMPONENT_RECEIVE_MULTIPLE =
  'quoteItems/BRIEF_COMPONENT_RECEIVE_MULTIPLE';
export const BRIEF_COMPONENT_REFRESH = 'quoteItems/BRIEF_COMPONENT_REFRESH';

export const BRIEF_COMPONENT_REFRESH_MULTIPLE =
  'quoteItems/BRIEF_COMPONENT_REFRESH_MULTIPLE';

export const RECEIVE_TEMPORARY_QUOTE_ITEM_IDS =
  'quote/RECEIVE_TEMPORARY_QUOTE_ITEM_IDS';

export const RECEIVE_IMPORT_FROM_ERP_TEMPORARY_QUOTE_ITEM =
  'quotes/RECEIVE_IMPORT_FROM_ERP_TEMPORARY_QUOTE_ITEM';

export const RECEIVE_IMPORT_FROM_ERP_TEMPORARY_QUOTE_ITEMS =
  'quotes/RECEIVE_IMPORT_FROM_ERP_TEMPORARY_QUOTE_ITEMS';

export const ADD_CONVERT_QUOTE_FILE_TO_QUOTE_ITEM_TASKS =
  'quotes/ADD_CONVERT_QUOTE_FILE_TO_QUOTE_ITEM_TASKS';

export const REMOVE_CONVERT_QUOTE_FILE_TO_QUOTE_ITEM_TASKS =
  'quotes/REMOVE_CONVERT_QUOTE_FILE_TO_QUOTE_ITEM_TASKS';

export const CLEAR_CONVERT_QUOTE_FILE_TO_QUOTE_ITEM_TASKS =
  'quotes/CLEAR_CONVERT_QUOTE_FILE_TO_QUOTE_ITEM_TASKS';

export const PURCHASED_COMPONENT_ADD_REQUEST =
  'quoteItems/PURCHASED_COMPONENT_ADD_REQUEST';
export const PURCHASED_COMPONENT_ADD_SUCCESS =
  'quoteItems/PURCHASED_COMPONENT_ADD_SUCCESS';
export const PURCHASED_COMPONENT_ADD_ERROR =
  'quoteItems/PURCHASED_COMPONENT_ADD_ERROR';

export const CREATE_QUOTE_ITEM_WITH_MANUAL_PART_REQUEST =
  'quoteItems/CREATE_QUOTE_ITEM_WITH_MANUAL_PART_REQUEST';
export const CREATE_QUOTE_ITEM_WITH_MANUAL_PART_SUCCESS =
  'quoteItems/CREATE_QUOTE_ITEM_WITH_MANUAL_PART_SUCCESS';
export const CREATE_QUOTE_ITEM_WITH_MANUAL_PART_ERROR =
  'quoteItems/CREATE_QUOTE_ITEM_WITH_MANUAL_PART_ERROR';

export const SNAP_TO_QUOTE_ITEM_HEADER_REQUEST =
  'quoteItems/SNAP_TO_QUOTE_ITEM_HEADER_REQUEST';

export const SET_QUOTE_ITEMS_UPDATING_REQUEST =
  'SET_QUOTE_ITEMS_UPDATING_REQUEST';
export const SET_QUOTE_ITEMS_UPDATING_SUCCESS =
  'SET_QUOTE_ITEMS_UPDATING_SUCCESS';
export const SET_QUOTE_ITEMS_UPDATING_ERROR = 'SET_QUOTE_ITEMS_UPDATING_ERROR';

export const REFRESH_BOM_ROLLUP_REQUEST =
  'quoteItems/REFRESH_REFRESH_BOM_ROLLUP_REQUEST';
export const REFRESH_BOM_ROLLUP_FINISHED =
  'quoteItems/REFRESH_BOM_ROLLUP_FINISHED';

export const UPDATE_QUOTE_ITEM_WORKFLOW_STEP_ERROR =
  'quoteItems/UPDATE_QUOTE_ITEM_WORKFLOW_STEP_ERROR';
export const UPDATE_QUOTE_ITEM_WORKFLOW_STEP_REQUEST =
  'quoteItems/UPDATE_QUOTE_ITEM_WORKFLOW_STEP_REQUEST';
export const UPDATE_QUOTE_ITEM_WORKFLOW_STEP_SUCCESS =
  'quoteItems/UPDATE_QUOTE_ITEM_WORKFLOW_STEP_SUCCESS';

export const RECEIVE_PROFIT_ITEMS = 'quoteItems/RECEIVE_PROFIT_ITEMS';
export const PROFIT_ITEM_CREATE_ERROR = 'quoteItems/PROFIT_ITEM_CREATE_ERROR';
export const PROFIT_ITEM_CREATE_REQUEST =
  'quoteItems/PROFIT_ITEM_CREATE_REQUEST';
export const PROFIT_ITEM_CREATE_SUCCESS =
  'quoteItems/PROFIT_ITEM_CREATE_SUCCESS';

export const PROFIT_ITEM_DELETE_ERROR = 'quoteItems/PROFIT_ITEM_DELETE_ERROR';
export const PROFIT_ITEM_DELETE_REQUEST =
  'quoteItems/PROFIT_ITEM_DELETE_REQUEST';

export const PROFIT_ITEM_UPDATE_ERROR = 'quoteItems/PROFIT_ITEM_UPDATE_ERROR';
export const PROFIT_ITEM_UPDATE_REQUEST =
  'quoteItems/PROFIT_ITEM_UPDATE_REQUEST';
export const PROFIT_ITEM_UPDATE_SUCCESS =
  'quoteItems/PROFIT_ITEM_UPDATE_SUCCESS';

export const PROFIT_ITEM_CELL_UPDATE_ERROR =
  'quoteItems/PROFIT_ITEM_CELL_UPDATE_ERROR';
export const PROFIT_ITEM_CELL_UPDATE_REQUEST =
  'quoteItems/PROFIT_ITEM_CELL_UPDATE_REQUEST';
export const PROFIT_ITEM_CELL_UPDATE_SUCCESS =
  'quoteItems/PROFIT_ITEM_CELL_UPDATE_SUCCESS';

export const UPDATE_PROFIT_ITEM_OVERRIDES_ERROR =
  'quoteItems/UPDATE_PROFIT_ITEM_OVERRIDES_ERROR';
export const UPDATE_PROFIT_ITEM_OVERRIDES_REQUEST =
  'quoteItems/UPDATE_PROFIT_ITEM_OVERRIDES_REQUEST';
export const UPDATE_PROFIT_ITEM_OVERRIDES_SUCCESS =
  'quoteItems/UPDATE_PROFIT_ITEM_OVERRIDES_SUCCESS';

export const REORDER_PROFIT_ITEMS_REQUEST =
  'quoteItems/REORDER_PROFIT_ITEMS_REQUEST';
export const REORDER_PROFIT_ITEMS_SUCCESS =
  'quoteItems/REORDER_PROFIT_ITEMS_SUCCESS';
export const REORDER_PROFIT_ITEMS_ERROR =
  'quoteItems/REORDER_PROFIT_ITEMS_ERROR';

export const RECEIVE_DISCOUNTS = 'quoteItems/RECEIVE_DISCOUNTS';
export const DISCOUNT_CREATE_ERROR = 'quoteItems/DISCOUNT_CREATE_ERROR';
export const DISCOUNT_CREATE_REQUEST = 'quoteItems/DISCOUNT_CREATE_REQUEST';
export const DISCOUNT_CREATE_SUCCESS = 'quoteItems/DISCOUNT_CREATE_SUCCESS';

export const DISCOUNT_DELETE_ERROR = 'quoteItems/DISCOUNT_DELETE_ERROR';
export const DISCOUNT_DELETE_REQUEST = 'quoteItems/DISCOUNT_DELETE_REQUEST';

export const DISCOUNT_UPDATE_ERROR = 'quoteItems/DISCOUNT_UPDATE_ERROR';
export const DISCOUNT_UPDATE_REQUEST = 'quoteItems/DISCOUNT_UPDATE_REQUEST';
export const DISCOUNT_UPDATE_SUCCESS = 'quoteItems/DISCOUNT_UPDATE_SUCCESS';

export const DISCOUNT_CELL_UPDATE_ERROR =
  'quoteItems/DISCOUNT_CELL_UPDATE_ERROR';
export const DISCOUNT_CELL_UPDATE_REQUEST =
  'quoteItems/DISCOUNT_CELL_UPDATE_REQUEST';
export const DISCOUNT_CELL_UPDATE_SUCCESS =
  'quoteItems/DISCOUNT_CELL_UPDATE_SUCCESS';

export const UPDATE_DISCOUNT_OVERRIDES_ERROR =
  'quoteItems/UPDATE_DISCOUNT_OVERRIDES_ERROR';
export const UPDATE_DISCOUNT_OVERRIDES_REQUEST =
  'quoteItems/UPDATE_DISCOUNT_OVERRIDES_REQUEST';
export const UPDATE_DISCOUNT_OVERRIDES_SUCCESS =
  'quoteItems/UPDATE_DISCOUNT_OVERRIDES_SUCCESS';

export const REORDER_DISCOUNTS_REQUEST = 'quoteItems/REORDER_DISCOUNTS_REQUEST';
export const REORDER_DISCOUNTS_SUCCESS = 'quoteItems/REORDER_DISCOUNTS_SUCCESS';
export const REORDER_DISCOUNTS_ERROR = 'quoteItems/REORDER_DISCOUNTS_ERROR';

export const UPDATE_METADATA_REQUEST = 'quoteItems/UPDATE_METADATA_REQUEST';
export const UPDATE_METADATA_SUCCESS = 'quoteItems/UPDATE_METADATA_SUCCESS';
export const UPDATE_METADATA_ERROR = 'quoteItems/UPDATE_METADATA_ERROR';

export const BOM_TABLE_INVALIDATE_REQUEST =
  'quoteItems/BOM_TABLE_INVALIDATE_REQUEST';
export const BOM_TABLE_INVALIDATE_FINISH =
  'quoteItems/BOM_TABLE_INVALIDATE_FINISH';

export const SET_QUOTE_APPS_PANEL_STATE =
  'quotes/quoteItems/SET_QUOTE_APPS_PANEL_STATE';
export const TOGGLE_QUOTE_APPS_PANEL_COLLAPSED =
  'quotes/quoteItems/TOGGLE_QUOTE_APPS_PANEL_COLLAPSED';
